import { useTranslation } from 'react-i18next';
import { Button } from 'src/common/components/Buttons/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactNode, useState } from 'react';
import Menu from '@mui/material/Menu';

type TemplateDownloadButtonProps = {
  children: ReactNode;
};

export const TemplateDownloadButton = ({ children }: TemplateDownloadButtonProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        id="templates-menu-button"
        aria-controls={open ? 'templates-menu-button' : undefined}
        iconStart={<KeyboardArrowDownIcon />}
        aria-haspopup="true"
        aria-expanded={open}
        variant="secondary"
        onClick={handleClick}
      >
        {t('bulkProvisioning.downloadTemplate')}
      </Button>
      <Menu
        id="templates-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'templates-menu-button',
          },
        }}
        onClose={handleClose}
        elevation={0}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
      >
        {children}
      </Menu>
    </div>
  );
};
